import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatCheckbox,
  MatRadioChange,
  MatStepper
} from '@angular/material';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { LabelService } from '../_service/label.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray
} from '@angular/forms';
import { Whmis2015Service } from '../_service/whmis2015.service';
import { AlertifyService } from '../_service/alertify.service';
import { BrowserDetectorService } from '../_service/browserDetector.service';

@Component({
  selector: 'app-product-label',
  templateUrl: './product-label.component.html',
  styleUrls: ['./product-label.component.css']
})
export class ProductLabelComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private labelService: LabelService,
    private formBuilder: FormBuilder,
    private whmis2015Service: Whmis2015Service,
    private alertify: AlertifyService,
    public detectBrowser: BrowserDetectorService
  ) {
    this.firstFormGroup = this.formBuilder.group({
      averyDimensions: ['', Validators.required],
    });
    this.secondFormGroup = this.formBuilder.group({
      safeHandlingInstructions: ['', [Validators.required, this.WhitespaceValidator]],
      signalWordVal: ['']
    });

    this.pictogramFormGroup = this.formBuilder.group({
      pictograms: this.formBuilder.array([])
    });

    this.thirdFormGroup = this.formBuilder.group({

    });
  }

  isLoading = false;
  confirmModal = false;

  pictograms: any = [];
  pictogramResponse: any;
  selected: any;
  pictogramArray: number;
  model: any = {};

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  averyCheckGroup: FormGroup;
  pictogramFormGroup: FormGroup;

  productId = this.passedData.productId;
  productName = this.passedData.productName;
  productCode = this.passedData.productCode;
  mfg_detail = this.passedData.mfg_detail;
  firstCtrl;
  safeHandlingInstructions;
  imageBind: any = [];
  test: any = [];
  selectedAveryDimension;
  width;
  height;
  rows;
  columns;
  margins;
  labelPerPage;
  signalWord;
  averyName;
  imageIsSelected: boolean;
  selectedImageValue: any = [];
  removedMessage: boolean;
  message: any;
  pictogramValue: any = [];
  signalWordValue = 0;
  selectedCheckBoxes: any = [];
  loadedImages: any = [];
  loading = false;

  averyId: any;
  modelId: number;
  ieVersion: any;

  labelType = 'ghs';

  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  dimensions: AveryDimensions[] = [
    {
      dimensionId: 1,
      dimensionName: 'Avery 5160',
      averyId: '5160',
      name: '1" x 2⅝"',
      averyDimension: '5160',
      toolTip: 'Avery 5160, 7666: 30 per sheet'
    },
    {
      dimensionId: 2,
      averyId: '5164',
      dimensionName: 'Avery 5164',
      name: '3⅓" x 4"',
      averyDimension: '5164',
      toolTip: 'Avery 5164, 5264, 8164, 48464, 48864, 55164, 58164: 6 per sheet'
    },
    {
      dimensionId: 3,
      dimensionName: 'Avery 5168',
      averyId: '5168',
      name: '3½" x 5"',
      averyDimension: '5168',
      toolTip: 'Avery 5168, 8168, 95935, 60503: 4 per sheet'
    },
    {
      dimensionId: 4,
      dimensionName: 'Avery 60504',
      averyId: '60504',
      name: '4" x 4"',
      averyDimension: '60504',
      toolTip: 'Avery 60504: 4 per sheet'
    },
    {
      dimensionId: 5,
      dimensionName: 'Avery 60502',
      averyId: '60502',
      name: '4¾" x 7¾',
      averyDimension: '60502',
      toolTip: 'Avery 60502: 2 per sheet'
    },
    {
      dimensionId: 6,
      dimensionName: 'Avery 60506',
      averyId: '60506',
      name: '2" x 2"',
      averyDimension: '60506',
      toolTip: 'Avery 60506: 12 per sheet'
    },
    {
      dimensionId: 7,
      dimensionName: 'Avery 60505',
      averyId: '60505',
      name: '2" x 4"',
      averyDimension: '60505',
      toolTip: 'Avery 5163, 5263, 5663, 5963, 5973, 7663, 8163, 8663, 8923, 15663, 18663, 48163, 48863, 55163, 58163, 60505: 10 per sheet'
    },
    {
      dimensionId: 8,
      dimensionName: 'Avery 60527',
      averyId: '60527',
      name: '1" x 2½"',
      averyDimension: '60527',
      toolTip: 'Avery 60527: 24 per sheet'
    },
    {
      dimensionId: 9,
      dimensionName: 'Avery 7662',
      averyId: '7662',
      name: '1⅓" x 4"',
      averyDimension: '7662',
      toolTip: 'Avery 7662: 14 per sheet'
    },
    {
      dimensionId: 10,
      dimensionName: 'Avery 5159',
      averyId: '5159',
      name: '1½" x 4"',
      averyDimension: '5159',
      toolTip: 'Avery 5159, 5259: 14 per sheet'
    },
    {
      dimensionId: 11,
      dimensionName: 'Avery 5161',
      averyId: '5161',
      name: '1" x 4"',
      averyDimension: '5161',
      toolTip: 'Avery 5161, 5261, 5661, 5961, 7661, 8161, 15661, 18661: 20 per sheet'
    }
  ];

  signalWords: SignalWords[] = [
    {
      signalId: 1,
      signalName: 'Danger'
    },
    {
      signalId: 2,
      signalName: 'Warning'
    },
    {
      signalId: 3,
      signalName: 'None'
    },
  ];
  checked: Boolean;

  ngOnInit() {
    this.pictogramReferences();
    this.detectBrowser.DetectIE();
    this.ieVersion = this.getInternetExplorerVersion();
  }

  getInternetExplorerVersion() {
    let rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer') {
      const ua = navigator.userAgent;
      const re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
      if (re.exec(ua) != null) {
        rv = parseFloat(RegExp.$1);
      }
    } else if (navigator.appName === 'Netscape') {
      const ua = navigator.userAgent;
      const re = new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})');
      if (re.exec(ua) != null) {
        rv = parseFloat(RegExp.$1);
      }
    }
    return rv;
  }

  checkedBoxeOpacity(id) {
    if (this.ieVersion < 10) { return 1; }

    if (this.selectedImageValue == id) {
      return 0.3;
    } else {
      return 1;
    }
  }

  checkedBoxess(id) {
    if (this.selectedImageValue == id) {
      return 'brightness(0.6)';
    } else {
      return 'none';
    }
  }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  textSizeCheck(id) {
    if (id === 1) {
      return 135;
    } else if (id === 8) {
      return 240;
    } else if (id === 10) {
      return 260;
    } else if (id === 9) {
      return 280;
    } else if (id === 2 || id === 5) {
      return 400;
    } else if (id === 3) {
      return 450;
    } else if (id === 4 || id === 6) {
      return 500;
    } else if (id === 11) {
      return 220;
    } else if (id === 7) {
      return 290;
    } else {
      return 500;
    }
  }

  safeHandlingValidator() {
    const value = this.secondFormGroup.get('safeHandlingInstructions').value.trim().length;

    if (value > 0) {
      return true;
    } else {
      return false;
    }
  }

  textBoxValidator(messageLength) {
    if (messageLength > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkedBoxes(id) {
    return (this.imageBind.find(x => x == id) == null) ? 'grayscale(100%)' : 'none';
  }

  onChangePictogram($event) {
    const pictograms = <FormArray>this.pictogramFormGroup.get('pictograms') as FormArray;
    this.pictogramValue = pictograms;
    this.selectedCheckBoxes = $event.source.value;
    console.log(this.selectedCheckBoxes);
    if ($event.checked) {
      pictograms.push(new FormControl($event.source.value));
    } else {
      const i = pictograms.controls.findIndex(x => x.value === $event.source.value);
      pictograms.removeAt(i);
    }
    this.imageBind = pictograms.value;
    console.log(this.imageBind);
  }

  imageDimensionNotSelected() {
    this.removedMessage = false;
    if (!this.imageIsSelected && !this.selectedImageValue) {
      this.removedMessage = true;
      this.message = `Please select a dimension`;
      console.log(this.message.value);
    } if (this.imageIsSelected === true && this.selectedImageValue !== null) {
      this.removedMessage = false;
      this.message = '';
    }
  }

  onSelectedLabelType(type: string) {
    this.labelType = type;
    const instructions = this.secondFormGroup.get('safeHandlingInstructions');
    const signalWordVal = this.secondFormGroup.get('signalWordVal');
    if (type === 'tracking') {
      instructions.clearValidators();
      instructions.setValue('');
      signalWordVal.setValue('');
      this.safeHandlingInstructions = '';
      this.signalWord = '';
      this.signalWordValue = 0;
      const pictograms = this.pictogramFormGroup.get('pictograms') as FormArray;
      while (pictograms.length > 0) {
        pictograms.removeAt(0);
      }
      this.imageBind = [];
    } else {
      instructions.setValidators([Validators.required, this.WhitespaceValidator]);
    }
    instructions.markAsUntouched();
    instructions.markAsPristine();
    signalWordVal.markAsUntouched();
    signalWordVal.markAsPristine();
    instructions.updateValueAndValidity();
    signalWordVal.updateValueAndValidity();

    if (this.stepper) {
      this.stepper.steps.forEach((step, index) => {
        if (index > 0) {
          step.interacted = false;
        }
      });
    }
  }

  onStepSelectionChange($event: StepperSelectionEvent) {
    if (!this.stepper || $event.selectedIndex >= $event.previouslySelectedIndex) {
      return;
    }
    this.stepper.steps.forEach((step, index) => {
      if (index > $event.selectedIndex) {
        step.interacted = false;
      }
    });
  }

  onSelectedAveryDimensions($event: MatRadioChange) {
    this.selectedAveryDimension = $event.source.value;
    console.log($event);
    this.imageIsSelected = $event.source.checked;
    this.selectedImageValue = $event.source.value;
    this.modelId = $event.source.value - 1;
    const averyDimensionId = $event.source.value;
    const avery = this.dimensions.find(x => x.dimensionId === averyDimensionId);
    this.averyId = avery.averyId;
    this.averyName = avery.dimensionName;

    const cap = this.textSizeCheck(averyDimensionId);
    const instructions = this.secondFormGroup.get('safeHandlingInstructions');
    if (typeof instructions.value === 'string' && instructions.value.length > cap) {
      const trimmed = instructions.value.substring(0, cap);
      instructions.setValue(trimmed);
      this.safeHandlingInstructions = trimmed;
    }
  }

  textAreaNewLine(length) {
    if (length >= 50) {
      return 'break-word';
    } else {
      return null;
    }
  }

  onSelectedSignalWords($event: MatRadioChange) {
    this.signalWordValue = $event.value;
    if ($event.source.value === 1) {
      this.signalWord = 'Danger';
    }
    if ($event.source.value === 2) {
      this.signalWord = 'Warning';
    }
    if ($event.source.value === 3) {
      this.signalWord = '';
      this.checked = true;
    }
  }

  pictogramReferences() {
    return this.labelService.getLabelPictograms().subscribe(res => {
      this.pictograms = res;
    });
  }

  productCodeLimited(productCode) {
    // console.log(productCode);
    if (productCode.length > 30) {
      return productCode.substring(0, 27) + '...';
    } else {
      return productCode;
    }
  }

  dialogBox() {
    this.confirmModal = true;
  }

  closeDialogBox() {
    this.confirmModal = false;
  }

  confirmDialogBox() {
    this.confirmModal = false;
    this.generateLabel();
  }

  generateLabel() {
    const params = new URLSearchParams();

    const isTracking = this.labelType === 'tracking';

    this.model.productName = this.productName;
    this.model.productCode = this.productCode;
    this.model.manufacturerName = this.mfg_detail;
    this.model.instructions = isTracking ? '' : this.safeHandlingInstructions.trim();
    this.model.signalWord = isTracking ? '' : this.signalWord;
    this.model.averyName = this.averyName;
    this.model.averyId = this.averyId;
    this.model.isTrackingLabel = isTracking;
    this.model.trackReceivedDate = isTracking;
    this.model.trackOpenedDate = isTracking;
    this.model.trackExpiryDate = isTracking;
    this.model.trackQcLine = isTracking;

    if (!isTracking) {
      for (const image of this.imageBind) {
        params.append('pictogramName', image);
      }
    }

    this.loading = true;

    return this.labelService.generateWorkPlaceLabel(this.model, params).subscribe(blob => {
      console.log(blob);
      if (blob) {
        const objectUrl = URL.createObjectURL(blob);
        if (window.navigator &&
          window.navigator.msSaveOrOpenBlob) { // for IE
          window.navigator.msSaveOrOpenBlob(blob, this.productName + `.pdf`);
        } else { // for Chrome
          window.open(objectUrl, '_blank');
        }
      }
      this.alertify.success('SDS Label has been successfully created');
      this.loading = false;
    }, error => {
      this.alertify.error('Something went wrong');
      this.loading = false;
    });
  }
}

export interface AveryDimensions {
  dimensionId: number;
  dimensionName: string;
  averyId: string;
  name: string;
  averyDimension: string;
  toolTip: string;
}

export interface SignalWords {
  signalId: number;
  signalName: string;
}